import axios from 'axios';

export const getTiers = async () => {
    try {
        const response = await axios.get('/api/tiers');
        return response.data;
    } catch (error) {
        console.error('Error fetching tiers:', error);
        throw error;
    }
};
